export default __webpack_public_path__ + "static/media/register-end-image.23ed8b43.svg";